import { ClientPolicy } from "../Client"
import { PaymentMethod } from "../PaymentMethod"
import { TransactionType } from "../TransactionType"
import * as api from '../task-detail-api'
import * as O from 'fp-ts/lib/Option'
import { getCoreDetail, getPayOutDetail } from "./common/payout"
import { PaymentType } from "../PaymentType"
import { pipe } from "fp-ts/lib/function"
import { InquiryComplaintData, PulseOpsFormat, TopUp } from "@pulseops/common"
import { VeriCanRiderClientInfo } from "./CancelRider"

export interface VERCancelRiderFromInception {
  tag: TransactionType.CANCEL_RIDER_FROM_INCEPTION
  cashOutList?: api.PaymentData.CashOutList
  branchName: string
  policyNumber: string
  methods: PaymentMethod[]
  totalPayoutAmount: number
  source: string
  lifeAssureds: LifeAssuredInfo[]
  riderNameList: InquiryComplaintData.IACSources[]
  riderRefundAmount: number
  // suspensePremium: number
  refundableFeeAmount: number
  netAmountAvailable: number
  reason: string
}

export interface LifeAssuredInfo {
  clientName: string
  lifeAssured: string
  submissionRiders: {
    productionName: string
    productCode: string
    riskCommDate: string
    riskCessDate: string
    sumAssured: string
    installmentPremium: string
    lifeNo: string
    coverageNo: string
    riderNo: string
    riderStatus: string
  }[]
}

export const CancelRiderFromInception = (
  taskDetail: api.CancelRiderFromInception & api.TaskDetailBase,
  clientPolicy: Array<ClientPolicy>,
  clientNameList: VeriCanRiderClientInfo[],
  riderNameList: InquiryComplaintData.IACSources[],
  extraPolicyInfo: TopUp.PolicyExtraInfo,
  // suspensePremium: number,
  poName: string,
  policyNumber: string,
  branchName?: string
): VERCancelRiderFromInception => {
  const coreStatus = getCoreDetail(taskDetail.coreResponseDetail, taskDetail.payload.body.cashOutOptions || [])
  const cashOutList =
    taskDetail.payload && taskDetail.payload.body
      ? taskDetail.payload.body.cashOutOptions?.filter(
        (x) =>
          PaymentType.BANKTRANSFER === x.type ||
          PaymentType.PAID_AT_BANK === x.type ||
          PaymentType.CASH_AT_COUNTER === x.type
      )
      : []
  const cutomedTotalPayoutAmount = pipe(
    taskDetail.payload.body.attributesExt,
    O.fromNullable,
    O.fold(
      () => 0,
      (payoutAmount) => payoutAmount.TOTAL_PAYOUT_AMOUNT || 0
    )
  )
  const coreRiderList = extraPolicyInfo.policyExtraInfoDetail.filter(
    (x) => x.lifeNo !== '01' || x.coverageNo !== '01' || x.riderNo !== '00'
  )
  const lifeAssuredList: LifeAssuredInfo[] = taskDetail.payload.body.lifeAssureds?.map((item) => {
    return {
      lifeAssured: item.lifeAssured ?? '',
      clientName: clientNameList.find((x) => x.clientNumberOfLA === item.lifeAssured)?.clientName || '',
      submissionRiders: item.riders.map((x) => {
        const customedRiskCommDate = coreRiderList.find(
          (coreItem) => coreItem.lifeNo === x.lifeNo && coreItem.productCode === x.productCode
        )?.riskCommDate
        const customedriskCessDate = coreRiderList.find(
          (coreItem) => coreItem.lifeNo === x.lifeNo && coreItem.productCode === x.productCode
        )?.riskCessDate
        const sumAssured = coreRiderList.find(
          (coreItem) => coreItem.lifeNo === x.lifeNo && coreItem.productCode === x.productCode
        )?.sumAssured
        const installmentPremium = coreRiderList.find(
          (coreItem) => coreItem.lifeNo === x.lifeNo && coreItem.productCode === x.productCode
        )?.installmentPremium
        return {
          riskCommDate: PulseOpsFormat.dateStrWF(customedRiskCommDate, 'DD/MM/YYYY'),
          riskCessDate: PulseOpsFormat.dateStrWF(customedriskCessDate, 'DD/MM/YYYY'),
          sumAssured: String(sumAssured || 0),
          installmentPremium: String(installmentPremium),
          productionName: '',
          productCode: x.productCode,
          lifeNo: x.lifeNo,
          coverageNo: x.coverageNo,
          riderNo: x.riderNo,
          riderStatus: x.status
        }
      })
    }
  }) || []
  return {
    tag: TransactionType.CANCEL_RIDER_FROM_INCEPTION,
    cashOutList: cashOutList,
    branchName: branchName || '',
    policyNumber: policyNumber,
    totalPayoutAmount: cutomedTotalPayoutAmount,
    source: taskDetail.payload.source,
    lifeAssureds: lifeAssuredList,
    riderRefundAmount: taskDetail.payload.body.attributesExt.RIDER_REFUND_AMOUNT || 0,
    // suspensePremium: suspensePremium,
    refundableFeeAmount: taskDetail.payload.body.attributesExt.REFUNDABLE_FEE_AMOUNT || 0,
    netAmountAvailable: taskDetail.payload.body.attributesExt.NET_AMOUNT_AVAILABLE || 0,
    reason: taskDetail.payload.body.attributesExt.REASON || '',
    riderNameList,
    methods: taskDetail.payload.body.cashOutOptions?.map((v, i) => ({
      method: v.type ?? '',
      detail: getPayOutDetail(
        {
          type: v.type as PaymentType,
          officeCode:
            (v.type === PaymentType.CASH_AT_COUNTER && v.attributesExt?.PVA_CASH_OUT_OPTION_INFO.officeCode) || '',

          bankAccount: {
            accountName:
              (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.accountName) ||
              (v.type === PaymentType.PAID_AT_BANK &&
                (v.attributesExt?.PAYEE_INFO?.payeeName === '' ? poName : v.attributesExt?.PAYEE_INFO?.payeeName)) ||
              (v.type === PaymentType.CASH_AT_COUNTER &&
                (v.attributesExt?.PAYEE_INFO?.payeeName === '' ? poName : v.attributesExt?.PAYEE_INFO?.payeeName)) ||
              ((v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.payeeName) ?? poName) ||
              '-',
            accountNo:
              (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.accountNo) ||
              ((v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.idNumber) ??
                taskDetail.clientNumber) ||
              ((v.type === PaymentType.CASH_AT_COUNTER && v.attributesExt?.PAYEE_INFO?.idNumber) ??
                taskDetail.clientNumber) ||
              ((v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.idNumber) ?? taskDetail.clientNumber) ||
              '-',
            bankName:
              (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.bankName) ||
              (v.type === PaymentType.PAID_AT_BANK && v.bankAccount?.bankName) ||
              '-',
            branchName:
              (v.type === PaymentType.BANKTRANSFER && branchName) ||
              (v.type === PaymentType.PAID_AT_BANK && branchName) ||
              undefined,
            bankCode: '-',
            branchCode: (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.branchCode) || '-'
          },
          phoneNumber: (v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.phone) || '',
          issuedDate: (v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.issuedDate) || '',
          issuedBy: (v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.issuedBy) || '',
          policy: {
            policyNo: v.policy?.policyNo || '-'
          }
        },
        clientPolicy
      ),
      amount: v.paymentOption.amount || 0,
      status: coreStatus[i].status,
      note: coreStatus[i].errorMes,
      action: '-',
      bankCode: v.type === PaymentType.BANKTRANSFER ? v.bankAccount?.bankName || '-' : undefined
    })) || []
  }
}